import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Google Analytics 4 — page-view tracker + global click event capture.
// The gtag script is loaded in public/index.html (gated on REACT_APP_GA_MEASUREMENT_ID).
export default function Analytics() {
  const { pathname, search } = useLocation();

  // Page view on every route change
  useEffect(() => {
    const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!id || typeof window.gtag !== "function") return;
    window.gtag("config", id, {
      page_path: pathname + search,
    });
  }, [pathname, search]);

  // Global click capture — any element with [data-track="event-name"]
  // fires a gtag event. Also auto-detects conversion-y testids so we don't
  // have to tag every button manually.
  useEffect(() => {
    if (typeof window === "undefined") return;

    const autoEventFor = (testid) => {
      if (!testid) return null;
      // Walkthrough = Calendly = top-of-funnel sales moment
      if (testid.includes("walkthrough-btn")) return "click_walkthrough";
      // Pricing / Jotform / pricing-doc = mid-funnel lead capture
      if (
        testid.includes("pricing-btn") ||
        testid.includes("pricing-doc-btn") ||
        testid === "jotform-open-btn"
      ) return "click_pricing_overview";
      // Fit-check completion = qualified district lead
      if (testid === "fit-submit-btn") return "submit_district_fit_check";
      // FAQ open
      if (testid.startsWith("faq-trigger-")) return "open_faq_item";
      // Calendly external link in BookDemo
      if (testid === "calendly-external-link") return "click_walkthrough";
      return null;
    };

    const onClick = (e) => {
      const el = e.target.closest("[data-track], [data-testid]");
      if (!el || typeof window.gtag !== "function") return;
      const explicit = el.getAttribute("data-track");
      const testid = el.getAttribute("data-testid") || undefined;
      const name = explicit || autoEventFor(testid);
      if (!name) return;
      const label = el.getAttribute("data-track-label") || testid;
      const location = el.getAttribute("data-track-location") || window.location.pathname;
      window.gtag("event", name, { label, location });
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
